import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
  Table,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Select from "react-select";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import axios from "axios";
import {
  getMedicationcategory,
  updateMedication,
  getCity,
  updateMedication_old_data,
  UpdateReport,
  GetPackages,
  GetReport,
  GetDepartment,
  Get_Settings,
  getBrachDetailsCountryCodeWise,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import Datetime from "react-datetime";
import InputMask from "react-input-mask";
import _ from "lodash";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

const options = [
  { value: "MER", label: "MER" },
  { value: "MUA", label: "MUA" },
  { value: "FBST", label: "FBST" },
  { value: "koenigsegg", label: "Koenigsegg" },
  { value: "Lipid Profile", label: "Lipid Profile" },
  { value: "FBC", label: "FBC" },
  { value: "ESR", label: "ESR" },
  { value: "LFT", label: "LFT" },
  { value: "RFT", label: "RFT" },
  { value: "HbA1c", label: "HbA1c" },
  { value: "HIV", label: "HIV" },
  { value: "HbSAg", label: "HbSAg" },
  { value: "ECG", label: "ECG" },
  { value: "Stress ECG", label: "Stress ECG" },
];
class editreport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      commision: "1",

      wt_commision: "",
      medicationcategory: [],
      labpackage: [],
      packageItems: [],
      package: [],
      m_category: "0",
      m_categoryError: null,
      description: "",
      descriptionError: null,
      price: "",
      priceError: null,
      unit_priceError: null,
      test_code: "",
      test_codeError: null,
      Dept_Name: "",
      Dept_NameError: null,
      Dept_details: [],
      Parent_Test: "",
      Parent_TestError: null,
      Short_Name: "",
      Display_Name: "",
      Method_Name: "",
      Specimen_Name: "",
      Container_Name: null,
      Min_Process_Time: null,
      Emergency_Process_Time: "",
      Reporting_Days: "",
      unit_price: "",
      _notificationSystem: null,
      cardHidden: true,
      city: "0",
      cityError: null,
      city_info: [],
      itemcodeunique: "",
      errormessages: [],
      reportname: "",
      reportnameError: null,
      is_featured: "2",
      tat: "",
      tatError: null,
      tags: [],
      branchList: [],
      branch: "",
      settingsData: "",
      reportType: "Lab",
      logo: "",
      logoData: "",
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.report_error = React.createRef();
  }

  handleChange = (tags) => {
    this.setState({ tags });
    console.log(
      `Option selected:`,
      this.state.tags.map((tags) => tags.value),
    );
  };

  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          <b>{getApiErrorMessage(error)}</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Report</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });

    setTimeout(() => {
      this.props.history.push("/admin/reportlist");
    }, 2000);
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var oldid = JSON.parse(localStorage.getItem("reportID"));

    Get_Settings(obj).then((res) => {
      const isMultiplePharmchy = res.data.data.find((data) => data.id === 11);
      this.setState({ settingsData: isMultiplePharmchy });
    });

    getBrachDetailsCountryCodeWise(token.country_code, obj).then((res) => {
      const branchListOptions = res.data.map((data) => {
        return {
          value: data.name,
          label: data.name,
        };
      });
      this.setState({ branchList: branchListOptions });
    });

    GetDepartment(obj)
      .then((res) => {
        this.setState({ Dept_details: res.data });
      })
      .catch((error) => {
        this.handleNetworkError("bl", error);
        console.log(error, "== error");
      });

    GetReport(oldid, obj).then((res) => {
      const data = res.data;

      var com = "";
      if (data.add_commision == 1) {
        com = "1";
      } else if (data.add_commision == 0) {
        com = "2";
      }
      var is_featured = "";
      if (data.is_featured == "1") {
        is_featured = "1";
      } else if (data.is_featured == "0") {
        is_featured = "2";
      }

      let newoptions = [];
      if (typeof data.tags !== "string") {
        data.tags.map((v) => {
          newoptions.push({ value: v, label: v });
        });
      }

      this.setState({
        // package : data.package,
        reportname: data.title,
        description: data.description,
        price: data.price,
        test_code: data.test_code,
        unit_price: data.unit_price,
        is_featured: is_featured,
        Dept_Name: data.department_id,
        Parent_Test: data.parent_test,
        Short_Name: data.short_name,
        Display_Name: data.display_name,
        Method_Name: data.method_name,
        Specimen_Name: data.specimen_name,
        Container_Name: data.container_name,
        Min_Process_Time: data.min_process_time,
        Emergency_Process_Time: data.emergency_process_time,
        Reporting_Days: data.reporting_days,
        tat: data.tat,
        tags: newoptions,
        branch: { label: data.district, value: data.district },
        reportType: data.report_type,
        logoData: data.icon_url,
      });
      let pc = [];
      let newdata = [];
      pc = data.report_packages;
      // console.log(hc,'hc ')
      if (pc == null) {
        this.setState({ package: null });
      } else {
        // const splic = pc.split(",");
        // console.log('splic',pc)
        pc.map((fd) => {
          // console.log(fd.id,fd.package_name);
          this.state.labpackage.map((r) => {
            if (r.id == fd.id) {
              // console.log(r)
              newdata.push({ value: r.id, label: r.package_name });
            }
          });
        });

        this.setState({ package: newdata });
      }
    });
    //   .catch((error) => {
    //     this.handleNetworkError('bl', error)
    //     console.log(error,"== error");
    //  });
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );

    let compelte = 1;
    let pg_no = 1;
    while (compelte == 1) {
      await GetPackages(obj, pg_no)
        // .then((response) => response.json())
        .then((response) => {
          const mdata = response.data;
          if (mdata.data.length == 0) {
            compelte = 0;
          } else {
            var array1 = this.state.labpackage;
            var array2 = array1.concat(mdata.data);
            this.setState({
              labpackage: array2,
            });

            let pcItems = [];
            this.state.labpackage.map((x, i) => {
              pcItems.push({ value: x.id, label: x.package_name });
            });
            this.setState({
              packageItems: pcItems,
            });
          }
        });
      pg_no++;
    }
  }
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };
  onSubmit = () => {
    this.setState({ errormessages: [] });
    let error = false;

    if (this.state.reportname.length == 0) {
      error = true;
      this.setState({
        reportnameError: (
          <small className="text-danger">Report Name is required.</small>
        ),
      });
    } else {
      this.setState({ reportnameError: null });
    }
    // if(this.state.package.length == 0 )
    //   {error = true
    //     this.setState({
    //      packageError: (
    //          <small className="text-danger">
    //            Package is required.
    //          </small>
    //        )
    //      })
    //    }else{ this.setState({ packageError: null });}
    if (this.state.unit_price.length == 0) {
      error = true;
      this.setState({
        unit_priceError: (
          <small className="text-danger">Unit Price is required.</small>
        ),
      });
    } else {
      this.setState({ unit_priceError: null });
    }
    if (this.state.price.length == 0) {
      error = true;
      this.setState({
        priceError: <small className="text-danger">Price is required.</small>,
      });
    } else {
      this.setState({ priceError: null });
    }
    if (this.state.Dept_Name == 0) {
      error = true;
      this.setState({
        Dept_NameError: (
          <small className="text-danger">Department Name is required.</small>
        ),
      });
    } else {
      this.setState({ Dept_NameError: null });
    }
    if (this.state.tat == 0) {
      error = true;
      this.setState({
        tatError: <small className="text-danger">TAT is required.</small>,
      });
    } else {
      this.setState({ tatError: null });
    }
    // if(this.state.Parent_Test.length == 0)
    // {error = true
    //    this.setState({
    //     Parent_TestError: (
    //         <small className="text-danger">
    //           Parent Test is required.
    //         </small>
    //       )
    //     })
    //   }else{ this.setState({ Parent_TestErrorError: null });}
    if (this.state.test_code.length == 0) {
      error = true;
      this.setState({
        test_codeError: (
          <small className="text-danger">Test Code is required.</small>
        ),
      });
    } else {
      this.setState({ test_codeError: null });
    }
    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      var data_unit_price = "";
      var oldid = JSON.parse(localStorage.getItem("reportID"));

      var is_featured = "";
      if (this.state.is_featured == "1") {
        is_featured = "1";
      } else if (this.state.is_featured == "2") {
        is_featured = "0";
      }
      var package_d = [];
      if (this.state.package == null) {
        package_d = "";
      } else {
        this.state.package.map((data) => {
          var array1 = package_d;
          var array2 = array1.concat(data.value);
          package_d = array2;
        });
      }
      UpdateReport(
        this.state.reportname,
        package_d,
        this.state.test_code,
        this.state.unit_price,
        this.state.price,
        this.state.description,
        is_featured,
        this.state.Dept_Name,
        this.state.Parent_Test,
        this.state.Short_Name,
        this.state.Display_Name,
        this.state.Method_Name,
        this.state.Specimen_Name,
        this.state.Container_Name,
        this.state.Min_Process_Time,
        this.state.Emergency_Process_Time,
        this.state.Reporting_Days,
        oldid,
        this.state.tat,
        this.state.tags.map((data) => data.value),
        this.state.branch.value,
        obj,
        this.state.reportType,
        this.state.logoData,
      )
        .then((res) => {
          if (res.data.success === false) {
            let message = res.data.data;
            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ errormessages: ermessage });
              this.report_error.current.focus();
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
            this.setState({
              package: "0",
              description: "",
              reportname: "",
              price: "",
              test_code: "",
              unit_price: "",
              Dept_Name: "0",
              Parent_Test: "",
              Display_Name: "",
              Method_Name: "",
              Specimen_Name: "",
              Short_Name: "",
              Container_Name: "",
              Min_Process_Time: null,
              Emergency_Process_Time: null,
              Reporting_Days: "",
              tat: "",
              is_featured: "2",
              tags: "",
            });
          }
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl", error);
        });
    }
  };
  uploadImage() {
    document.getElementById("selectImage").click();
  }
  handleFileImageChange = async (e) => {
    const file = e.target.files[0];
    this.setState({ processing: true });
    const fdata = new FormData();
    fdata.append("company_logo", file);
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const url = process.env.REACT_APP_NOT_SECRET_CODE + "/b2b/comapany/logo";
    try {
      const res = await axios.post(url, fdata, {
        headers: {
          Authorization: "Bearer " + obj,
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          "X-Request-Id": "124",
        },
      });
      const imageUrl = res.data.data.company_logo_url;
      this.setState({
        logoData: imageUrl,
        logo: file,
        processing: false,
      });
    } catch (error) {
      this.setState({ processing: false });
    }
  };
  handleRemoveMedia = () => {
    this.setState({
      logoData: null,
      selectedFile: [],
      logo: "",
    });
  };

  render() {
    const medicaioncat = this.state.medicationcategory;
    const city_info = this.state.city_info;
    const itemcodeunique = this.state.itemcodeunique;
    const errormessages = this.state.errormessages;

    const { tags } = this.state;

    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.report_error}
        />
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                    <Row>
                      <Col md={12} xs={12} lg={12} sm={12}>
                        <Col md={6} xs={12} lg={6} sm={6}>
                          <FormGroup>
                            <ControlLabel>Report Name</ControlLabel>
                            <FormControl
                              name="reportname"
                              value={this.state.reportname}
                              onChange={(event) => {
                                this.setState({
                                  reportname: event.target.value,
                                });
                                event.target.value === ""
                                  ? this.setState({
                                      reportnameError: (
                                        <small className="text-danger">
                                          Report Name is required.
                                        </small>
                                      ),
                                    })
                                  : this.setState({ reportnameError: null });
                              }}
                              placeholder="Enter Report Name"
                              type="text"
                            />
                            {this.state.reportnameError}
                          </FormGroup>

                          {/* {this.category_drop} */}
                          <FormGroup>
                            <ControlLabel>Package</ControlLabel>
                            <Select
                              className="react-select info"
                              classNamePrefix="react-select"
                              placeholder="Package"
                              name="package"
                              closeMenuOnSelect={false}
                              isMulti
                              value={this.state.package}
                              onChange={(value) =>
                                this.setState({
                                  package: value,
                                })
                              }
                              options={this.state.packageItems}
                            />

                            {/* {this.state.packageError}        */}
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Unit Price</ControlLabel>
                            <FormControl
                              name="unit_price"
                              value={this.state.unit_price}
                              onWheel={(e) => e.target.blur()}
                              onChange={(event) => {
                                this.setState({
                                  unit_price: event.target.value,
                                });
                                event.target.value === ""
                                  ? this.setState({
                                      unit_priceError: (
                                        <small className="text-danger">
                                          Unit Price is required.
                                        </small>
                                      ),
                                    })
                                  : this.setState({ unit_priceError: null });
                              }}
                              placeholder="Enter Unit Price"
                              type="number"
                            />
                            {this.state.unit_priceError}
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Price</ControlLabel>
                            <FormControl
                              name="price"
                              value={this.state.price}
                              onWheel={(e) => e.target.blur()}
                              onChange={(event) => {
                                this.setState({ price: event.target.value });
                                event.target.value === ""
                                  ? this.setState({
                                      priceError: (
                                        <small className="text-danger">
                                          Price is required.
                                        </small>
                                      ),
                                    })
                                  : this.setState({ priceError: null });
                              }}
                              placeholder="Enter Price"
                              type="number"
                            />
                            {this.state.priceError}
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Test Code</ControlLabel>
                            <FormControl
                              name="test_code"
                              value={this.state.test_code}
                              onWheel={(e) => e.target.blur()}
                              onChange={(event) => {
                                this.setState({
                                  test_code: event.target.value,
                                });
                                event.target.value === ""
                                  ? this.setState({
                                      test_codeError: (
                                        <small className="text-danger">
                                          TestCode is required.
                                        </small>
                                      ),
                                    })
                                  : this.setState({ test_codeError: null });
                              }}
                              placeholder="Enter test code"
                              type="number"
                            />
                            {this.state.test_codeError}
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Description </ControlLabel>
                            <textarea
                              name="description"
                              value={this.state.description}
                              onChange={(event) => {
                                this.setState({
                                  description: event.target.value,
                                });
                              }}
                              placeholder="Enter Description"
                              className="form-control"
                              rows={2}
                              cols={3}
                            ></textarea>
                          </FormGroup>
                          <FormGroup className="">
                            <ControlLabel>Is Featured ? &nbsp;</ControlLabel>
                            <div className="report_feature">
                              <Radio
                                number="7"
                                option="1"
                                name="is_featured"
                                onChange={this.onChange}
                                checked={this.state.is_featured === "1"}
                                label="Yes"
                              />{" "}
                              &nbsp;
                              <Radio
                                number="8"
                                option="2"
                                name="is_featured"
                                onChange={this.onChange}
                                checked={this.state.is_featured === "2"}
                                label="No"
                              />
                            </div>
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Department Name</ControlLabel>
                            <select
                              className="form-control"
                              name="Dept_Name"
                              value={this.state.Dept_Name}
                              onChange={(event) => {
                                this.setState({
                                  Dept_Name: event.target.value,
                                });
                                event.target.value === "0"
                                  ? this.setState({
                                      Dept_NameError: (
                                        <small className="text-danger">
                                          Department Name is required.
                                        </small>
                                      ),
                                    })
                                  : this.setState({ Dept_NameError: null });
                              }}
                            >
                              <option value="0">Select Department</option>
                              {this.state.Dept_details.map((dept) => (
                                <option value={dept.id}>
                                  {dept.department_name}
                                </option>
                              ))}
                            </select>
                            {this.state.Dept_NameError}
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Parent Test</ControlLabel>
                            <FormControl
                              name="Parent_Test"
                              value={this.state.Parent_Test}
                              onChange={(event) => {
                                this.setState({
                                  Parent_Test: event.target.value,
                                });
                                // event.target.value === ""
                                //   ? this.setState({
                                //     Parent_TestError: (
                                //         <small className="text-danger">
                                //           Parent Test is required.
                                //         </small>
                                //       )
                                //     })
                                //   : this.setState({ Parent_TestError: null });
                              }}
                              placeholder="Enter Parent Test"
                              type="text"
                            />
                            {/* {this.state.Parent_TestError} */}
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Tags</ControlLabel>
                            <Select
                              className="react-select info"
                              classNamePrefix="react-select"
                              placeholder="Select Tags"
                              name="tags"
                              closeMenuOnSelect={false}
                              isMulti
                              value={this.state.tags}
                              onChange={(value) =>
                                this.setState({
                                  tags: value,
                                })
                              }
                              options={options}
                            />
                          </FormGroup>
                          <FormGroup style={{ display: "inline-grid" }}>
                            <ControlLabel>Upload Logo</ControlLabel>
                            <input
                              style={{ display: "none" }}
                              id="selectImage"
                              type="file"
                              className="form-control"
                              accept="image/*"
                              onChange={this.handleFileImageChange}
                            />
                            <Button
                              onClick={this.uploadImage}
                              style={{ color: "#2B3A41" }}
                            >
                              {" "}
                              <i
                                className={
                                  !this.state.logoData
                                    ? "fa fa-plus"
                                    : "fa fa-pencil fa-fw"
                                }
                              ></i>{" "}
                              {!this.state.logoData
                                ? "Choose Logo"
                                : "Change Logo"}
                            </Button>
                            <div style={{ textAlign: "center" }}>
                              {this.state.logoData && (
                                <>
                                  <div
                                    style={{
                                      position: "relative",
                                      display: "inline-block",
                                    }}
                                  >
                                    <i
                                      className="fa fa-close"
                                      onClick={this.handleRemoveMedia}
                                      style={{
                                        position: "absolute",
                                        top: "9px",
                                        borderRadius: "3px",
                                        padding: "2px 0px",
                                        cursor: "pointer",
                                        zIndex: 2,
                                        color: "white",
                                        backgroundColor: "#CB0404",
                                        right: "0px",
                                      }}
                                    ></i>
                                    <img
                                      src={this.state.logoData}
                                      alt="Uploaded preview"
                                      style={{
                                        width: "220px",
                                        height: "230px",
                                        marginTop: 10,
                                      }}
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                          </FormGroup>
                        </Col>
                        <Col md={6} xs={12} lg={6} sm={6}>
                          <FormGroup>
                            <ControlLabel>Short Name</ControlLabel>
                            <FormControl
                              name="Short_Name"
                              value={this.state.Short_Name}
                              onChange={(event) => {
                                this.setState({
                                  Short_Name: event.target.value,
                                });
                              }}
                              placeholder="Enter Short Name"
                              type="text"
                            />
                          </FormGroup>
                          <FormGroup style={{ marginTop: "-6px" }}>
                            <ControlLabel>Display Name</ControlLabel>
                            <FormControl
                              name="Display_Name"
                              value={this.state.Display_Name}
                              onChange={(event) => {
                                this.setState({
                                  Display_Name: event.target.value,
                                });
                                // event.target.value === ""
                                //   ? this.setState({
                                //     test_codeError: (
                                //         <small className="text-danger">
                                //           TestCode is required.
                                //         </small>
                                //       )
                                //     })
                                //   : this.setState({ test_codeError: null });
                              }}
                              placeholder="Enter Display Name"
                              type="text"
                            />
                            {/* {this.state.test_codeError} */}
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Method Name</ControlLabel>
                            <FormControl
                              name="Method_Name"
                              value={this.state.Method_Name}
                              onChange={(event) => {
                                this.setState({
                                  Method_Name: event.target.value,
                                });
                                // event.target.value === ""
                                //   ? this.setState({
                                //     test_codeError: (
                                //         <small className="text-danger">
                                //           TestCode is required.
                                //         </small>
                                //       )
                                //     })
                                //   : this.setState({ test_codeError: null });
                              }}
                              placeholder="Enter Method Name"
                              type="text"
                            />
                            {/* {this.state.test_codeError} */}
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Specimen Name</ControlLabel>
                            <FormControl
                              name="Specimen_Name"
                              value={this.state.Specimen_Name}
                              onChange={(event) => {
                                this.setState({
                                  Specimen_Name: event.target.value,
                                });
                                // event.target.value === ""
                                //   ? this.setState({
                                //     test_codeError: (
                                //         <small className="text-danger">
                                //           TestCode is required.
                                //         </small>
                                //       )
                                //     })
                                //   : this.setState({ test_codeError: null });
                              }}
                              placeholder="Enter Specimen Name"
                              type="text"
                            />
                            {/* {this.state.test_codeError} */}
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Cointainer Name</ControlLabel>
                            <FormControl
                              name="Container_Name"
                              value={this.state.Container_Name}
                              onChange={(event) => {
                                this.setState({
                                  Container_Name: event.target.value,
                                });
                                // event.target.value === ""
                                //   ? this.setState({
                                //     test_codeError: (
                                //         <small className="text-danger">
                                //           TestCode is required.
                                //         </small>
                                //       )
                                //     })
                                //   : this.setState({ test_codeError: null });
                              }}
                              placeholder="Enter Container Name"
                              type="text"
                            />
                            {/* {this.state.test_codeError} */}
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Minmum Process Time</ControlLabel>
                            <InputMask
                              mask="99:99"
                              className="form-control"
                              placeholder="12:00"
                              name="Min_Process_Time"
                              onChange={this.onChange}
                              value={this.state.Min_Process_Time}
                              maskChar=" "
                            />

                            {/* {this.state.test_codeError} */}
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Emergency Process Time</ControlLabel>
                            <InputMask
                              mask="99:99"
                              className="form-control"
                              placeholder="12:00"
                              name="Emergency_Process_Time"
                              onChange={this.onChange}
                              value={this.state.Emergency_Process_Time}
                              maskChar=" "
                            />

                            {/* {this.state.test_codeError} */}
                          </FormGroup>
                          <FormGroup style={{ marginTop: "24px" }}>
                            <ControlLabel>Reporting Days</ControlLabel>
                            <FormControl
                              name="Reporting_Days"
                              value={this.state.Reporting_Days}
                              onWheel={(e) => e.target.blur()}
                              onChange={(event) => {
                                this.setState({
                                  Reporting_Days: event.target.value,
                                });
                                // event.target.value === ""
                                //   ? this.setState({
                                //     test_codeError: (
                                //         <small className="text-danger">
                                //           TestCode is required.
                                //         </small>
                                //       )
                                //     })
                                //   : this.setState({ test_codeError: null });
                              }}
                              placeholder="Enter Reporting Days"
                              min={1}
                              type="number"
                            />
                            {/* {this.state.test_codeError} */}
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>TAT</ControlLabel>
                            <select
                              name="tat"
                              value={this.state.tat}
                              className="form-control"
                              onChange={(event) => {
                                this.setState({ tat: event.target.value });
                                event.target.value === "0"
                                  ? this.setState({
                                      tatError: (
                                        <small className="text-danger">
                                          TAT is required.
                                        </small>
                                      ),
                                    })
                                  : this.setState({ tatError: null });
                              }}
                            >
                              <option value="0">Select the Day</option>
                              <option value="SAME DAY">SAME DAY</option>
                              <option value="2 DAYS">2 DAYS</option>
                              <option value="3 DAYS">3 DAYS</option>
                              <option value="4 DAYS">4 DAYS</option>
                              <option value="5 DAYS">5 DAYS</option>
                            </select>
                            {this.state.tatError}
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Report Type</ControlLabel>
                            <select
                              name="reportType"
                              value={this.state.reportType}
                              className="form-control"
                              onChange={(event) => {
                                this.setState({
                                  reportType: event.target.value,
                                });
                              }}
                            >
                              <option value="lab">Lab</option>
                              <option value="homecare">Home Care</option>
                            </select>
                          </FormGroup>
                          {this.state.settingsData.setting_value == "true" && (
                            <FormGroup>
                              <ControlLabel>Branch</ControlLabel>
                              <Select
                                name="district"
                                placeholder="Branch"
                                options={this.state.branchList}
                                onChange={(value) =>
                                  this.setState({ branch: value })
                                }
                                value={this.state.branch}
                              />
                            </FormGroup>
                          )}
                        </Col>
                      </Col>
                    </Row>
                    <br />
                    <Button
                      onClick={this.onSubmit.bind(this)}
                      class="btn-color" //bsStyle="info"
                      fill
                    >
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default editreport;
